import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import assinaturaCadastroCelular from "../../assets/landing/assinatura-cadastro-celular.jpeg";
import assinaturaCelular from "../../assets/landing/assinatura-celular.jpeg";
import codigoAtivacaoCelular from "../../assets/landing/codigo-ativacao-celular.jpeg";
import dashboardImage from "../../assets/landing/dashboard.png";
import entregaEpiCelular from "../../assets/landing/entrega-epi-celular.jpeg";
import reconhecimentoFacialImage from "../../assets/landing/reconhecimento-facial.jpeg";
import selecaoEpiCelular from "../../assets/landing/selecao-epi-celular.jpeg";
import selecaoUsuarioCelular from "../../assets/landing/selecao-usuario-celular.jpeg";
import splashScreenCelular from "../../assets/landing/splash-screen-celular.jpeg";
import trackEpiLogo from "../../assets/landing/track-epi-logo.jpeg";
import "../../styles/landing-page.css";

const benefits = [
  {
    icon: "bi-box-seam",
    title: "Controle completo de EPIs",
    description:
      "Cadastre, organize e acompanhe todos os equipamentos em um painel único e mais confiável.",
  },
  {
    icon: "bi-person-bounding-box",
    title: "Reconhecimento facial no celular",
    description:
      "Valide a identidade do colaborador pelo celular antes da liberação do EPI, com menos dúvida e mais segurança.",
  },
  {
    icon: "bi-eye",
    title: "Validação visual da entrega",
    description:
      "O fluxo de entrega orienta o usuário com retorno visual para deixar o processo mais claro no campo.",
  },
  {
    icon: "bi-phone",
    title: "Campo e escritório conectados",
    description:
      "Use o sistema no computador e no celular para ativação, entrega, aceite e acompanhamento.",
  },
];

const heroHighlights = [
  "Computador e aplicativo integrados",
  "Reconhecimento facial pelo celular",
  "Validação da entrega",
  "Entrega com assinatura digital",
  "Relatórios prontos para consulta",
];

const smartDeliverySignals = [
  {
    label: "Entrada segura",
    value: "Face reconhecida no próprio celular antes da entrega.",
  },
  {
    label: "Condução assistida",
    value: "A interface destaca a etapa atual e indica o próximo passo.",
  },
  {
    label: "Prova da entrega",
    value: "Reconhecimento, aceite e confirmação ficam no mesmo fluxo.",
  },
];

const smartDeliverySteps = [
  {
    icon: "bi-camera-video",
    title: "Abrir a câmera no celular",
    description:
      "O operador inicia a entrega no aplicativo e faz a validação facial sem sair do fluxo no celular.",
  },
  {
    icon: "bi-patch-check",
    title: "Entrega validada",
    description:
      "Depois da validação facial, a entrega segue para aceite e confirmação final com rastreabilidade completa.",
  },
];

const mobileJourneyGroups = [
  {
    title: "Entrada e seleção",
    description:
      "O fluxo no celular começa com ativação simples e identificação correta do usuário antes da escolha dos itens.",
    items: [
      {
        image: codigoAtivacaoCelular,
        title: "Código de ativação",
        caption: "Entrada rápida no aplicativo pelo celular.",
      },
      {
        image: selecaoUsuarioCelular,
        title: "Seleção de usuário",
        caption: "Identificação antes da continuidade do processo.",
      },
      {
        image: selecaoEpiCelular,
        title: "Seleção de EPI",
        caption: "Escolha dos equipamentos disponíveis para entrega.",
      },
    ],
  },
  {
    title: "Entrega, aceite e orientação",
    description:
      "Depois da seleção, o aplicativo conduz a entrega com reconhecimento facial no celular, assinatura e validação visual do processo.",
    items: [
      {
        image: entregaEpiCelular,
        title: "Entrega no aplicativo",
        caption: "Registro da entrega com foco em agilidade no campo e validação facial antes da liberação.",
      },
      {
        image: assinaturaCadastroCelular,
        title: "Assinatura no cadastro",
        caption: "Aceite digital no momento do processo.",
      },
      {
        image: assinaturaCelular,
        title: "Confirmação da entrega",
        caption: "Validação visual do envio dos EPIs concluídos.",
      },
      {
        image: splashScreenCelular,
        title: "Orientação de uso",
        caption: "Tela educativa reforçando o uso correto dos equipamentos com apoio visual.",
      },
    ],
  },
];

const mobileJourneyScenes = mobileJourneyGroups.flatMap((group, groupIndex) =>
  group.items.map((item, itemIndex) => ({
    ...item,
    id: `${groupIndex + 1}-${itemIndex + 1}`,
    stageNumber: groupIndex + 1,
    stageTitle: group.title,
    stageDescription: group.description,
    sceneNumber: itemIndex + 1,
    groupSize: group.items.length,
  }))
);

const processSteps = [
  {
    number: "01",
    title: "Cadastre a operação",
    description:
      "Estruture empresas, usuários, funcionários e os EPIs que fazem parte da rotina.",
  },
  {
    number: "02",
    title: "Execute e acompanhe",
    description:
      "Faça entregas, acompanhe vencimentos e registre evidências sem perder contexto.",
  },
  {
    number: "03",
    title: "Comprove e decida",
    description:
      "Use relatórios, histórico e rastreabilidade para agir com mais segurança operacional.",
  },
];

const socialProof = [
  {
    value: "Computador + celular",
    label: "Uma experiência única para gestão interna e operação em campo.",
  },
  {
    value: "Face + entrega + assinatura",
    label: "Validação da pessoa, liberação do EPI e confirmação final no mesmo processo.",
  },
  {
    value: "Celular guiado",
    label: "Uma experiência pensada para operação pelo celular, com orientação clara durante a entrega.",
  },
];

const whatsappUrl = "https://wa.me/5519992895729";
const appDownloadUrl = "/TrackEPI-2.9.8.apk";

function LandingPage() {
  const [showTopButton, setShowTopButton] = useState(false);
  const [activeMobileScene, setActiveMobileScene] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopButton(window.scrollY > 640);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActiveMobileScene((current) => (current + 1) % mobileJourneyScenes.length);
    }, 3600);

    return () => window.clearInterval(interval);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const activeScene = mobileJourneyScenes[activeMobileScene];
  const nextScene = mobileJourneyScenes[(activeMobileScene + 1) % mobileJourneyScenes.length];
  const nextNextScene = mobileJourneyScenes[(activeMobileScene + 2) % mobileJourneyScenes.length];

  return (
    <div className="landing-page">
      <div className="landing-floating">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noreferrer"
          className="landing-floating__btn landing-floating__btn--whatsapp"
          aria-label="Falar no WhatsApp"
        >
          <i className="bi bi-whatsapp"></i>
        </a>

        {showTopButton && (
          <button
            type="button"
            className="landing-floating__btn landing-floating__btn--top"
            onClick={scrollToTop}
            aria-label="Voltar ao topo"
          >
            <i className="bi bi-arrow-up"></i>
          </button>
        )}
      </div>

      <header className="landing-header">
        <div className="landing-brand">
          <div className="landing-brand__mark">
            <img src={trackEpiLogo} alt="Logo Track EPI" />
          </div>
          <div>
            <div className="landing-brand__name">Track EPI</div>
            <div className="landing-brand__tag">Gestão profissional de EPIs</div>
          </div>
        </div>

        <nav className="landing-nav">
          <a href="#produto">Produto</a>
          <a href="#beneficios">Benefícios</a>
          <a href="#entrega-mobile">Entrega no celular</a>
          <a href="#galeria">Aplicativo</a>
          <a href="#contato">Contato</a>
        </nav>
      </header>

      <main className="landing-main">
        <section className="landing-hero">
          <div className="landing-hero__copy">
            <span className="landing-eyebrow">Track EPI</span>
            <h1>Uma plataforma para controlar EPIs com mais clareza, rastreabilidade e confiança.</h1>
            <p>
              O Track EPI reúne cadastro, entrega, reconhecimento facial pelo celular,
              assinatura, relatórios e acompanhamento em um produto
              que ajuda a operação a ganhar organização e velocidade.
            </p>

            <div className="landing-hero__actions">
              <Link to="/acesso?mode=register" className="landing-btn landing-btn--primary">
                Criar conta
              </Link>
              <Link to="/acesso?mode=login" className="landing-btn landing-btn--secondary">
                Fazer login
              </Link>
              <a
                href={appDownloadUrl}
                download="TrackEPI-2.9.8.apk"
                className="landing-btn landing-btn--download"
              >
                <i className="bi bi-android2"></i>
                Download do app
              </a>
            </div>

            <div className="landing-hero__highlights">
              {heroHighlights.map((item) => (
                <span key={item} className="landing-chip">
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="landing-hero__media">
            <div className="landing-hero__orb landing-hero__orb--one"></div>
            <div className="landing-hero__orb landing-hero__orb--two"></div>
            <div className="landing-hero__badge landing-hero__badge--face">
              <small>Feito para celular</small>
              <strong>Reconhecimento facial</strong>
              <span>Validação antes da entrega do EPI.</span>
            </div>

            <div className="landing-device landing-device--laptop">
              <div className="landing-laptop">
                <div className="landing-laptop__screen-shell">
                  <div className="landing-laptop__camera"></div>
                  <div className="landing-device__screen landing-device__screen--laptop">
                    <img src={dashboardImage} alt="Painel do Track EPI no computador" />
                  </div>
                </div>
                <div className="landing-laptop__deck">
                  <div className="landing-laptop__trackpad"></div>
                </div>
              </div>
            </div>

            <div className="landing-device landing-device--phone">
              <div className="landing-device__notch"></div>
              <div className="landing-device__screen landing-device__screen--phone">
                <img src={entregaEpiCelular} alt="Tela do aplicativo Track EPI no celular" />
              </div>
            </div>

          </div>
        </section>

        <section id="produto" className="landing-section landing-section--intro">
          <div className="landing-section__lead">
            <span className="landing-eyebrow">O produto</span>
            <h2>O Track EPI foi pensado para empresas que precisam parar de improvisar o controle operacional.</h2>
            <p>
              Em vez de processos dispersos, planilhas e baixa visibilidade, a plataforma
              oferece uma base única para acompanhar equipamentos, entregas, documentos e
              responsabilidades com mais profissionalismo.
            </p>
          </div>

          <div className="landing-proof-grid">
            {socialProof.map((item) => (
              <article key={item.value} className="landing-proof-card">
                <strong>{item.value}</strong>
                <p>{item.label}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="beneficios" className="landing-section">
          <div className="landing-section__lead">
            <span className="landing-eyebrow">Benefícios</span>
            <h2>Mais controle para quem administra e mais segurança para quem executa.</h2>
          </div>

          <div className="landing-benefits-grid">
            {benefits.map((benefit) => (
              <article key={benefit.title} className="landing-panel">
                <div className="landing-panel__icon">
                  <i className={`bi ${benefit.icon}`}></i>
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="landing-section">
          <div className="landing-section__lead">
            <span className="landing-eyebrow">Como funciona</span>
            <h2>Um fluxo simples para sair do cadastro e chegar ao controle real da operação.</h2>
          </div>

          <div className="landing-steps-grid">
            {processSteps.map((step) => (
              <article key={step.number} className="landing-step-card">
                <span>{step.number}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="entrega-mobile" className="landing-section">
          <div className="landing-smart-delivery">
            <div className="landing-smart-delivery__copy">
              <span className="landing-eyebrow">Entrega inteligente no celular</span>
              <h2>Reconhecimento facial pelo celular antes da entrega do EPI, com orientação clara na tela.</h2>
              <p>
                A experiência foi pensada para o celular: validar o colaborador, mostrar a
                etapa atual com destaque visual e conduzir a confirmação da entrega de um
                jeito simples para quem está no campo.
              </p>

              <div className="landing-smart-delivery__signals">
                {smartDeliverySignals.map((item) => (
                  <article key={item.label} className="landing-smart-delivery__signal">
                    <small>{item.label}</small>
                    <strong>{item.value}</strong>
                  </article>
                ))}
              </div>

              <div className="landing-smart-delivery__steps">
                {smartDeliverySteps.map((item) => (
                  <article key={item.title} className="landing-smart-delivery__step">
                    <div className="landing-smart-delivery__step-icon">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                    <div>
                      <strong>{item.title}</strong>
                      <span>{item.description}</span>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            <div className="landing-smart-delivery__visual">
              <div className="landing-smart-delivery__halo landing-smart-delivery__halo--one"></div>
              <div className="landing-smart-delivery__halo landing-smart-delivery__halo--two"></div>

              <div className="landing-smart-delivery__floating landing-smart-delivery__floating--result">
                <i className="bi bi-shield-check"></i>
                <div>
                  <small>Validação concluída</small>
                  <strong>EPI liberado com segurança</strong>
                </div>
              </div>

              <div className="landing-smart-delivery__phone">
                <div className="landing-smart-delivery__notch"></div>
                <div className="landing-smart-delivery__screen">
                  <img src={reconhecimentoFacialImage} alt="Reconhecimento facial no celular para validar a entrega de EPI" />
                  <div className="landing-smart-delivery__scanner">
                    <div className="landing-smart-delivery__scan-mark" aria-hidden="true">
                      <div className="landing-smart-delivery__scan-shell">
                        <i className="bi bi-person-bounding-box"></i>
                        <div className="landing-smart-delivery__scan-line-clean"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="galeria" className="landing-section">
          <div className="landing-gallery-block landing-gallery-block--mobile">
            <div className="landing-gallery-block__header">
              <div>
                <strong>Jornada do aplicativo no celular</strong>
                <span>O fluxo agora muda automaticamente, destacando uma tela por vez com leitura mais clara, reconhecimento facial e visual mais forte no celular.</span>
              </div>
            </div>

            <div className="landing-mobile-parallax">
              <div className="landing-mobile-parallax__copy">
                <span className="landing-mobile-parallax__eyebrow">
                  {`Etapa ${activeScene.stageNumber}`}
                </span>
                <strong>{activeScene.stageTitle}</strong>
                <p>{activeScene.stageDescription}</p>

                <div className="landing-mobile-parallax__details">
                  <div className="landing-mobile-parallax__detail">
                    <small>Cena atual</small>
                    <span>{activeScene.title}</span>
                  </div>
                  <div className="landing-mobile-parallax__detail">
                    <small>Posição no fluxo</small>
                    <span>{`${String(activeMobileScene + 1).padStart(2, "0")} / ${String(
                      mobileJourneyScenes.length
                    ).padStart(2, "0")}`}</span>
                  </div>
                </div>

                <div className="landing-mobile-parallax__timeline">
                  {mobileJourneyScenes.map((scene, index) => (
                    <button
                      key={scene.id}
                      type="button"
                      className={`landing-mobile-parallax__step ${
                        index === activeMobileScene ? "landing-mobile-parallax__step--active" : ""
                      }`}
                      onClick={() => setActiveMobileScene(index)}
                    >
                      <span>{`0${index + 1}`}</span>
                      <div>
                        <strong>{scene.title}</strong>
                        <small>{scene.stageTitle}</small>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              <div className="landing-mobile-parallax__stage">
                <div className="landing-mobile-parallax__glow landing-mobile-parallax__glow--one"></div>
                <div className="landing-mobile-parallax__glow landing-mobile-parallax__glow--two"></div>

                <article className="landing-mobile-card landing-mobile-card--depth-two" aria-hidden="true">
                  <div className="landing-mobile-card__screen">
                    <img src={nextNextScene.image} alt="" />
                  </div>
                </article>

                <article className="landing-mobile-card landing-mobile-card--depth-one" aria-hidden="true">
                  <div className="landing-mobile-card__screen">
                    <img src={nextScene.image} alt="" />
                  </div>
                </article>

                <article className="landing-mobile-card landing-mobile-card--active" key={activeScene.id}>
                  <div className="landing-mobile-card__screen">
                    <img src={activeScene.image} alt={activeScene.title} />
                  </div>
                  <div className="landing-mobile-card__caption">
                    <small>{`Cena ${String(activeScene.sceneNumber).padStart(2, "0")}`}</small>
                    <strong>{activeScene.title}</strong>
                    <span>{activeScene.caption}</span>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section id="contato" className="landing-section landing-section--cta">
          <div className="landing-cta">
            <div className="landing-cta__copy">
              <span className="landing-eyebrow">Comece agora</span>
              <h2>Leve o Track EPI para sua empresa e apresente um fluxo mais profissional desde o primeiro acesso.</h2>
              <p>
                Crie sua conta ou entre no sistema para começar a organizar sua operação
                com mais controle, rastreabilidade e agilidade.
              </p>
            </div>

            <div className="landing-cta__actions">
              <Link to="/acesso?mode=register" className="landing-btn landing-btn--primary">
                Criar conta
              </Link>
              <Link to="/acesso?mode=login" className="landing-btn landing-btn--secondary">
                Fazer login
              </Link>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div>
          <strong>Track EPI</strong>
          <span>Gestão profissional de EPIs para operações que precisam de controle, rastreabilidade e agilidade.</span>
        </div>
        <div className="landing-footer__links">
          <Link to="/acesso?mode=login">Entrar</Link>
          <Link to="/acesso?mode=register">Cadastro</Link>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
